import { TrackerService } from '../../core/tracker/tracker.service';
import { AccountService } from '../../core/auth/account.service';
import { Router } from "@angular/router";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { FlowManagerService } from '../../core/util/flow-manager.service';
import { JhiEventManager } from '../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/tracker/tracker.service";
import * as i2 from "../../core/auth/account.service";
import * as i3 from "@angular/router";
import * as i4 from "../../core/util/flow-manager.service";
import * as i5 from "../../ng-jhipster/service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "../util/long-press.directive";
import * as i8 from "@angular/common";
import * as i9 from "../support/support-dropdown.component";
import * as i10 from "../language/language-selector/language-selector.component";
import * as i11 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i12 from "../flow/hide-if-flow.directive";
import * as i13 from "../track-user-activity.directive";
const _c0 = ["myDrop"];
function WellbeingHeaderComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r0.logoRoute);
} }
function WellbeingHeaderComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 13);
    i0.ɵɵelement(2, "use", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function WellbeingHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "h3", 16);
    i0.ɵɵelementEnd();
} }
function WellbeingHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3, "powered by inuka");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c1 = function () { return { "track": "click", "name": "ss_booksession_btn_clicked" }; };
function WellbeingHeaderComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function WellbeingHeaderComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onBookSession(); });
    i0.ɵɵelement(1, "h5", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r4.bookSessionLink);
    i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(2, _c1));
} }
function WellbeingHeaderComponent_language_selector_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "language-selector", 21);
} }
const _c2 = function (a0) { return { "transform": a0 }; };
function WellbeingHeaderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22, 23);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "button", 24);
    i0.ɵɵlistener("click", function WellbeingHeaderComponent_div_12_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.menuButtonClicked(); });
    i0.ɵɵelement(4, "img", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 26);
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵelementStart(7, "a", 27);
    i0.ɵɵlistener("click", function WellbeingHeaderComponent_div_12_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onBookSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵelementStart(9, "div", 28);
    i0.ɵɵelement(10, "language-selector");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(1);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c2, _r9.isOpen() ? "rotate(90deg)" : "rotate(0deg)"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r6.bookSessionLink);
} }
export class WellbeingHeaderComponent {
    constructor(trackerService, accountService, router, flowManagerService, eventManager) {
        this.trackerService = trackerService;
        this.accountService = accountService;
        this.router = router;
        this.flowManagerService = flowManagerService;
        this.eventManager = eventManager;
        this.isWellbeingStart = this.router.url.includes('/wellbeing-start');
        this.isWellbeingScan = this.router.url.includes('/wellbeing-scan');
    }
    ngOnInit() {
        this.bookSessionLink = "/session/schedule-session";
        this.logoRoute = this.accountService.isAuthenticated() ? "/index-user" : "/register-corporate";
        if (this.flowManagerService.isFlowInProgress('sss')) {
            this.logoRoute = null;
        }
    }
    countryIsZimbabwe() {
        return window.userCountry === 'Zimbabwe';
    }
    onBookSession() {
        this.trackerService.sendActivity("self_scan_book_session_clicked");
    }
    menuButtonClicked() {
        let url = this.router.routerState.snapshot.url;
        let trackerString = url.substring(0, url.length - 1);
        console.log(trackerString);
        this.trackerService.sendActivity(trackerString + '_menu_btn_clicked');
    }
    toggleConsoleLogViewer() {
        this.eventManager.broadcast('toggleConsoleLogViewer');
    }
}
WellbeingHeaderComponent.ɵfac = function WellbeingHeaderComponent_Factory(t) { return new (t || WellbeingHeaderComponent)(i0.ɵɵdirectiveInject(i1.TrackerService), i0.ɵɵdirectiveInject(i2.AccountService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.FlowManagerService), i0.ɵɵdirectiveInject(i5.JhiEventManager)); };
WellbeingHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingHeaderComponent, selectors: [["wellbeing-header"]], viewQuery: function WellbeingHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myDrop = _t.first);
    } }, decls: 13, vars: 7, consts: [[1, "olha-theme"], ["id", "page-navbar", 1, "navbar", "navbar-dark"], ["longPress", "", 1, "d-flex", "align-items-center", "left-side-margin", 3, "mouseLongPress"], [3, "routerLink", 4, "ngIf"], [4, "ngIf"], ["class", "d-none d-md-block d-lg-block d-xl-block top-center", 4, "ngIf"], [1, "d-flex", "align-items-center", "right-side-margin"], ["jhiHideIfFlow", "sss", "class", "d-none d-md-block d-lg-block d-xl-block btn btn-secondary align-items-center justify-content-center mr-3", 3, "routerLink", "trackUserActivity", "click", 4, "ngIf"], [1, "ml-3", "mr-3"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "ml-3", "mr-3"], ["class", "d-md-none ml-3 mr-3", 4, "ngIf"], ["ngbDropdown", "", "class", "olha-theme d-inline-block text-dark align-middle d-md-none ml-3", 4, "ngIf"], [3, "routerLink"], [2, "width", "4.7rem!important", "height", "30px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#inuka-logo-left"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "top-center"], ["jhiTranslate", "inukaNgApp.navbar.title.wellbeingStart"], ["src", "../../../../content/images/inuka/FB-inuka-small.png", "alt", "FB-inuka-small image", 2, "height", "60px"], [1, "align-bottom", 2, "font-size", "12px", "margin-top", "40px!important"], ["jhiHideIfFlow", "sss", 1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "btn", "btn-secondary", "align-items-center", "justify-content-center", "mr-3", 3, "routerLink", "trackUserActivity", "click"], ["jhiTranslate", "wellBeingResult.button.bookASession"], [1, "d-md-none", "ml-3", "mr-3"], ["ngbDropdown", "", 1, "olha-theme", "d-inline-block", "text-dark", "align-middle", "d-md-none", "ml-3"], ["myDrop", "ngbDropdown"], ["ngbDropdownToggle", "", "id", "navbar-dropdown-button", 1, "navbar-toggler", 3, "click"], ["src", "../../../../content/images/inuka/hamburger-medium.png", "alt", "hamburger-medium image", 1, "navbar-dropdown-hamburger", 2, "transform", "rotate(90deg)", 3, "ngStyle"], ["ngbDropdownMenu", "", "aria-labelledby", "support-dropdown", 1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-location"], ["jhiTranslate", "wellBeingResult.button.bookASession", 1, "hamburger-menu-item", "ml-3", 3, "routerLink", "click"], [1, "ml-3"]], template: function WellbeingHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "nav", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("mouseLongPress", function WellbeingHeaderComponent_Template_div_mouseLongPress_2_listener() { return ctx.toggleConsoleLogViewer(); });
        i0.ɵɵtemplate(3, WellbeingHeaderComponent_a_3_Template, 3, 1, "a", 3);
        i0.ɵɵtemplate(4, WellbeingHeaderComponent_span_4_Template, 3, 0, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, WellbeingHeaderComponent_div_5_Template, 2, 0, "div", 5);
        i0.ɵɵtemplate(6, WellbeingHeaderComponent_div_6_Template, 4, 0, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, WellbeingHeaderComponent_button_8_Template, 2, 3, "button", 7);
        i0.ɵɵelement(9, "support-dropdown", 8);
        i0.ɵɵelement(10, "language-selector", 9);
        i0.ɵɵtemplate(11, WellbeingHeaderComponent_language_selector_11_Template, 1, 0, "language-selector", 10);
        i0.ɵɵtemplate(12, WellbeingHeaderComponent_div_12_Template, 11, 4, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.logoRoute);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.logoRoute);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.countryIsZimbabwe() && ctx.isWellbeingStart);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.countryIsZimbabwe());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isWellbeingScan);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isWellbeingStart);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isWellbeingScan);
    } }, directives: [i6.NgbNavbar, i7.LongPressDirective, i8.NgIf, i9.SupportDropdownComponent, i10.LanguageSelectorComponent, i3.RouterLinkWithHref, i11.JhiTranslateDirective, i12.HideIfFlowDirective, i3.RouterLink, i13.TrackUserActivityDirective, i6.NgbDropdown, i6.NgbDropdownToggle, i8.NgStyle, i6.NgbDropdownMenu], styles: [".left-side-margin[_ngcontent-%COMP%]{margin-left:20px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:20px !important}h3[_ngcontent-%COMP%]{margin-bottom:0}h5[_ngcontent-%COMP%]{margin-bottom:0}.dropdown-menu-location[_ngcontent-%COMP%]{top:25px !important;right:25px !important}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}a[_ngcontent-%COMP%]{text-decoration:none}#page-navbar[_ngcontent-%COMP%]{box-shadow:none;background:#f7f4eb}.hamburger-menu-item[_ngcontent-%COMP%]{background-color:#fff;color:#44a38d !important}.hamburger-menu-item[_ngcontent-%COMP%]:hover{background-color:#44a38d;color:#fff !important}@media(min-width: 768px){.left-side-margin[_ngcontent-%COMP%]{margin-left:84px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:84px !important}}"] });
